import { useIntl } from '@atlassian/jira-intl';
import {
	type MenuNode,
	MenuNodeType,
} from '@atlassian/jira-software-context-menu/src/common/types.tsx';
import { DeleteCardType } from '../../../../../../model/modals/types';
import { useBacklogSelector, useBacklogActionCreator } from '../../../../../../state';
import { openModal } from '../../../../../../state/actions/modals';
import { canDeleteIssues } from '../../../../../../state/selectors/permissions';
import { DELETE_ISSUE_MENU_ID } from '../../constants';
import messages from '../../messages';
import type { Props, ContentProps } from './types';

export const useDeleteIssueContent = ({
	isDeleteEnabled,
	onDeleteIssue,
	selectedCardIds,
}: ContentProps): MenuNode[] => {
	const { formatMessage } = useIntl();

	if (!isDeleteEnabled || selectedCardIds.length > 1) return [];

	return [
		{
			type: MenuNodeType.Item,
			label: formatMessage(messages.delete),
			id: DELETE_ISSUE_MENU_ID,
			onClick: onDeleteIssue,
		},
	];
};

export const useDeleteIssue = ({ issueId, selectedCardIds }: Props) => {
	const isDeleteEnabled = useBacklogSelector(canDeleteIssues);
	const onDeleteIssue = useBacklogActionCreator(() =>
		openModal({
			type: DeleteCardType,
			payload: {
				cardId: issueId,
			},
		}),
	);

	return useDeleteIssueContent({
		isDeleteEnabled,
		onDeleteIssue,
		selectedCardIds,
	});
};
